import ConnectAPI from "../../../services/api";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2';
import { Col, Container, Row, ThemeProvider } from "react-bootstrap";
import { Select, TextBox, Table, DatePicker, TextArea, Button, Checkbox, FilePicker, Stepper, IconCheckmark, Tooltip, IconInfo, Modal  } from '@veneer/core';
import { buildSpecialConditionFormData } from "./Functions/Submit";
import { validateNewSpecialConditionsProcess } from "./Functions/Validation";
import { getStartDateForSubmit, getEndDateForSubmit, getSelectedPressIds, getCombineClicksIds, getSpecialConditionTooltipDescription } from "./Functions/Utils";
import { selectionState, selectRow, selectAllPageItems, getSelectedPresses, hasMixed6kPlusSelection } from "./Functions/Selection";
import { getChannelListData, getEndUserListData, getPressListData, getSpConditionListData, getConfigPressData } from "./Functions/Helpers";
import { showMaxCostPerImpression, showBonusSpecialTable, showCombineClicks, showTiersUp, showMinumimDiscount, showBonusLSDiscount, showRunLength, showFixedBonus } from "./Functions/ShowSC";
import { showFixedBonusReview, showMaxCostPerImpressionReview, showBonusSpecialTableReview, showCombineClicksReview, showTiersUpReview, showMinumimDiscountReview, showBonusLSDiscountReview, showRunLengthReview } from "./Functions/ReviewSC";

function NewSpecialConditionsProcess(props){
    const connectApi = new ConnectAPI();
    const { t } = useTranslation();
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    const [isLoading, setIsLoading] = useState(false);

    //Copeado
    /* Metodos para guardar las condiciones especiales. */
    const [oneShotDisabled, setOneShotDisabled] = useState(false)
    const [whiteDisabled, setWhiteDisabled] = useState(false)
    const [segmentSelected, setSegmentSelected] = useState("")

    const [isLastTier, setIsLastTier] = useState(false)
    const [minPrint, setMinPrint] = useState(1)
    const [maxPrint, setMaxPrint] = useState("")

    const [blackCpp, setBlackCpp] = useState("")
    const [otherCpp, setOtherCpp] = useState("")
    const [oneShotCpp, setOneShotCpp] = useState("")
    const [whiteCpp, setWhiteCpp] = useState("")
    const [compensationTable, setCompensationTable] = useState([])
    const [lowCoverage, setLowCoverage] = useState(false)

    const [category, setCategory] = useState([])
    const [channelList, setChannelList] = useState([])
    const [viewChannel, setViewChannel] = useState(false)
    const [channel, setChannel] = useState("")
    const [endUserList, setEndUserList] = useState([])
    const [endUser, setEndUser] = useState("")
    const [serieFix, setSerieFix] = useState("")
    const [seriesList, setSeriesList] = useState([])
    const [selectedPress, setSelectedPress] = useState(false)
    const [series, setSeries] = useState("")
    const [pressListBySeries, setPressListBySeries] = useState ([])
    const [pressListBySeriesFilter, setPressListBySeriesFilter] = useState ([])
    const [specialConditionTypeList, setSpecialConditionTypeList] = useState ([])
    const [specialConditionType, setSpecialConditionType] = useState("")
    const [segment, setSegment] = useState([])
    const [segmentFlag, setSegmentFlag] = useState(false)
    const [startDate, setStartDate] = useState("")
    const [opdNumber, setOpdNumber] = useState("")
    const [effectiveMonths, setEffectiveMonths] = useState(1)
    const [objetive, setObjetive] = useState("")
    const [justification, setJustification] = useState("")
    const [competition, setCompetition] = useState("")
    const [resultFuture, setResultFuture] = useState("")
    const [comments, setComments] = useState("")
    const [endUserContactName, setEndUserContactName] = useState("")
    const [endUserContactPosition, setEndUserContactPosition] = useState("")
    const [endUserEmail, setEndUserEmail] = useState("")
    const [file, setFile] = useState("")
    const [showModalSegment, setShowModalSegment] = useState(false)
    const [showMessage, setShowMessage] = useState("")
    const [previusInformation, setPreviusInformation] = useState(false)
    const [informationFromHP, setInformationFromHP] = useState(false)

    const tooltipDescription = getSpecialConditionTooltipDescription(specialConditionType, t);

    const resetDefaul = () => {
        setEndUser("");
        setSerieFix("");
        setSeriesList([]);
        setSelectedPress(false);
        setSeries("");
        setPressListBySeries([]);
        setPressListBySeriesFilter([]);
        setSpecialConditionTypeList([]);
        setSpecialConditionType("");
        setSegment([]);
        setSegmentSelected("");
        setStartDate("");
        setOpdNumber("")
        setEffectiveMonths(1);
        setObjetive("");
        setJustification("");
        setCompetition("");
        setResultFuture("");
        setComments("");
        setMinimumImp(0);
        setPercentage();
        if(informationFromHP) 
            setPreviusInformation(true);
        else {
            setChannel("");
            setEndUserList([]);
            setCategory([]);
        }
    }

    useEffect(() => {
        //validate location
        let validate = false;
        currentUser.urls.forEach( ur => {
            if ( ur == window.location.pathname ) validate=true;
        });
        if (validate==false){
            const { history } = props;
            history.push({ pathname: '/' });
        }//end validate

        //console.log("-------------------------currentUser------------------------")
        //currentUser.idCustomer = "CL0047"; currentUser.idRole = 5;

        if(currentUser.idRole == 5 ) {// 5 - Sales Op Admin  
            setPreviusInformation(true);
            setInformationFromHP(true);
        }

        setEndUserContactName(currentUser.name);
        setEndUserContactPosition(currentUser.jobPosition);
        setEndUserEmail(currentUser.email);

        const fetchData = () => {
            connectApi.get("api/Channels", "", (status, data) => {
                getChannelListData({
                    data,
                    currentUser,
                    setChannelList,
                    setCategory,
                    setChannel,
                    fetchEndUsers,
                    setViewChannel
                });
            }).catch((error) => {
                Swal.fire("Error " + error?.response?.status, error?.response?.data, "error");
            });
        };

        fetchData();
    }, []);

    const fetchEndUsers = (channelId) => {
        setEndUser("");
        setEndUserList([]);
        setEndUserListCombineClicks([]);
        setIsLoading(true);
        connectApi.get("api/Channels/endUsers", {
            params: { customerId: channelId, status: "Active" }
        }, (status, data) => {
            getEndUserListData({
            data,
            setEndUserList,
            setEndUserListCombineClicks,
            });
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
            Swal.fire("Error " + error?.response?.status, error?.response?.data, "error");
        });
    };
    useEffect(() => { setPressListBySeriesFilter(pressListBySeries.filter((item) => item.series == series && item.segment == segment)); }, [series]);
    
    let xUser = "";
    const fetchPress = (endUserId) => {
        xUser = endUserId;
        connectApi.get(
            "api/Channels/endUsers/" + endUserId + "/ActivePresses",
            { params: { endUserId } },
            (status, data) => {
            getPressListData({
                data,
                setSegmentFlag,
                setPressListBySeries,
                setSegment,
                setSegmentSelected,
                setSeriesList,
                setSerieFix,
                setSeries,
                fetchSpConditions,
            });
            }
        ).catch((error) => {
            Swal.fire("Error " + error?.response?.status, error?.response?.data, "error");
        });
    };
    
    const fetchSpConditions = (serie) => {
        let interUser = endUser[0];
        if (endUser[0] === undefined || endUser[0] === "") interUser = xUser;

        setSeries([serie]);

        connectApi.get(
            "api/Channels/SpConditionType",
            { params: { series: serie, idenduser: interUser } },
            (status, data) => {
            getSpConditionListData({
                data,
                setSpecialConditionTypeList,
                setSpecialConditionType,
            });
            }
        ).catch((error) => {
            Swal.fire("Error " + error?.response?.status, error?.response?.data, "error");
        });
    };

    function setSegmentFind(segment){
        setSegment([segment]);
        setSegmentSelected(segment);

        if(serieFix!="")
            fetchSpConditions(serieFix);

        let array = pressListBySeries.filter((item) => item.segment == segment).map(x => x.series).filter((x, idx, item) => item.indexOf(x) === idx ).map(x => {return{ value: x, label: x } });
        setSeriesList(array)
        
        if(array.length == 1)
            fetchSpConditions(array[0].value);
        else 
            setSeries("");
    }

    /// Codigo de las condiciones especiales
    const [multiplierConfig, setMultiplierConfig] = useState(1)
    // Bonus LSDisconunt Table
    const [bonusLSDiscount, setBonusLSDiscount] = useState([])
    const [bonusLSDiscountSend, setBonusLSDiscountSend] = useState([])
    const [bonusLS, setBonusLS] = useState("")
    const [minPrintLS, setMinPrintLS] = useState(1)
    const [maxPrintLS, setMaxPrintLS] = useState("")
    const [isAddOneMin, setIsAddOneMin] = useState(false)
    const [isLastTierLS, setIsLastTierLS] = useState(false)
    // Bonus Special Table    
    const [bonusTable, setBonusTable] = useState([])
    const [bonus, setBonus] = useState("")
    // Fixed Bonus
    const [percentage, setPercentage] = useState()
    const [minimumImp, setMinimumImp] = useState(0)
    // Run Length
    const [MinimumPrint, setMinimumPrint]=useState(0);
    // Combine clicks
    const [channelCombineClicks, setChannelCombineClicks] = useState("")
    const [endUserListCombineClicks, setEndUserListCombineClicks] = useState([])
    const [endUserCombineClicks, setEndUserCombineClicks] = useState("")
    const [endUserNameCombine, setEndUserNameCombine] = useState("")
    const [combineClicksList, setCombineClicksList] = useState([])
    // Minimun Discount
    const [minumimDiscount, setMinumumDiscount] = useState("")

    const configpress = (status, data) => {
        getConfigPressData({
            data,
            setOneShotDisabled,
            setWhiteDisabled,
            setMultiplierConfig,
            setWhiteCpp,
            t,
            Swal,
        });
    };
    // Fin de los Metodos para rellenar las special conditions
    

    const handleSelect = (event, index) => {
        const updatedData = selectRow(pressListBySeriesFilter, event.target.checked, index);
        const selectedPresses = getSelectedPresses(updatedData);

        setPressListBySeriesFilter(updatedData);

        if (selectedPresses.length > 0) {
            if (selectedPresses[0].series >= "4") {
            for (let i = 0; i < updatedData.length; i++) {
                if (updatedData[i].rowConfig.selected === true) {
                connectApi.get(
                    "api/Channels/getconfigbyserial",
                    {
                    params: {
                        payload: updatedData[i].idPress.substr(0, 4),
                    },
                    },
                    configpress
                );
                break;
                }
            }
            }
        }

        if (selectedPresses.length > 0) {
            if (hasMixed6kPlusSelection(selectedPresses)) {
            setShowMessage(t("different6K+"));
            setPressListBySeriesFilter(selectRow(updatedData, false, index));
            setShowModalSegment(true);
            } else {
            setSelectedPress(true);
            }
        } else {
            setSelectedPress(false);
        }
    };

    const handleSelectAll = (event) => {
        const updatedData = selectAllPageItems(pressListBySeriesFilter, event.target.checked);
        const selectedPresses = getSelectedPresses(updatedData);

        setPressListBySeriesFilter(updatedData);

        if (selectedPresses.length > 0) {
            if (selectedPresses[0].series >= "4") {
            for (let i = 0; i < updatedData.length; i++) {
                if (updatedData[i].rowConfig.selected === true) {
                connectApi.get(
                    "api/Channels/getconfigbyserial",
                    {
                    params: {
                        payload: updatedData[i].idPress.substr(0, 4),
                    },
                    },
                    configpress
                );
                break;
                }
            }
            }
        }

        if (selectedPresses.length > 0) {
            if (hasMixed6kPlusSelection(selectedPresses)) {
            setShowMessage(t("runLengthDifferentSegment"));
            setPressListBySeriesFilter(selectAllPageItems(updatedData, false));
            setShowModalSegment(true);
            } else {
            setSelectedPress(true);
            }
        } else {
            setSelectedPress(false);
        }
    };

    const handleSubmit = () => {
        const selectedPressListToUpload = getSelectedPressIds(pressListBySeriesFilter);
        const combineClicksToUpload = getCombineClicksIds(combineClicksList);

        const data = buildSpecialConditionFormData({
            specialConditionType,
            endUser,
            channel,
            category,
            series,
            endUserContactName,
            endUserContactPosition,
            startDate,
            effectiveMonths,
            percentage,
            minimumImp,
            justification,
            competition,
            objetive,
            resultFuture,
            comments,
            opdNumber,
            endUserEmail,
            selectedPressListToUpload,
            compensationTable,
            bonusTable,
            bonusLSDiscountSend,
            combineClicksToUpload,
            MinimumPrint,
            multiplierConfig,
            minumimDiscount,
        });

        const handleUploadFinal = (status, response) => {
            Swal.fire(t('SpConditionSubmitted'), "", "success");
            resetDefaul();
        };

        connectApi.post("api/Channels/UploadSCProcess", data, handleUploadFinal)
            .catch((error) => {
            Swal.fire(
                "Error " + error?.response?.status,
                error?.response?.data,
                "error"
            );
            });

        const deepcopyItems = defaultJson.map((item) => ({ ...item }));
        setStepItems(deepcopyItems);
        setCurrentIndex(0);
    };
    
    const validateForm = () => {
        const result = validateNewSpecialConditionsProcess({
            t,
            justification,
            objective: objetive,
            resultFuture,
            competition,
            comments,
            endUserContactName,
            endUserContactPosition,
            startDate,
            effectiveMonths,
            specialConditionType,
            compensationTable,
            bonusTable,
            combineClicksList,
            bonusLSDiscountSend,
            lowCoverage,
            percentage,
            minimumImp,
            minumimDiscount,
            MinimumPrint,
            category
        });

        if (!result.isValid) {
            alert(result.message);
            return;
        } else
            handleSubmit();
        
    };
    const defaultJson = [
      {
        label: t('endUserAndPress'),
        status: 'current',
        step: '1',
      }, {
        label: t('infoSpecialCondition'),
        status: 'incomplete',
        step: '2',
      }, {
        label: t('infoProgram'),
        status: 'incomplete',
        step: '3',
      }, {
        label: t('reviewAndSend'),
        status: 'incomplete',
        step: '4',
      },
    ];
    //status: 'disabled' //status: 'incomplete',
    const [stepItems, setStepItems] = useState(defaultJson);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleNextButtonOnChange = () => {
        if(currentIndex <= 2){
            const newStepItems = [...stepItems];
            const newSelectedItem = newStepItems[currentIndex + 1];
            const oldSelectedItem = newStepItems[currentIndex];
            newSelectedItem.status = 'current';
            oldSelectedItem.status = 'complete';
            oldSelectedItem.step = <IconCheckmark filled />;

            setCurrentIndex(currentIndex + 1);
            setStepItems(newStepItems);
        } else {
            const deepcopyItems = defaultJson.map((item) => ({ ...item }));
            setStepItems(deepcopyItems);
            setCurrentIndex(0);
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
  
    const handleResetButtonOnChange = () => {
        if(currentIndex > 0){
            const newStepItems = [...stepItems];
            const newSelectedItem = newStepItems[currentIndex - 1];
            const oldSelectedItem = newStepItems[currentIndex];
            newSelectedItem.status = 'current';
            oldSelectedItem.status = 'complete';

            setCurrentIndex(currentIndex - 1);
            setStepItems(newStepItems);
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    
    const handleOnChange = (event, index) => {
        const newStepItems = [...stepItems];
        const newSelectedItem = newStepItems[index];
        const oldSelectedItem = stepItems[currentIndex];
        if (newSelectedItem.status !== 'incomplete'){
            newSelectedItem.status = 'current';
            oldSelectedItem.status = 'pending';
            
            setCurrentIndex(index);
            setStepItems(newStepItems);
        }
      };

    const formStyle = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: 'stretch',
        marginTop: '30px'
    };

    const buttonsContainer = { display: 'flex', justifyContent: 'space-evenly', marginTop: '30px' };
    const nextButtonStyle = { width: '15%' };
    const resetButtonStyle = { width: '15%' };

    const [checkList1, setCheckList1] = useState(false);
    const [checkList2, setCheckList2] = useState(false);
    const [checkList3, setCheckList3] = useState(false);
    const [checkList4, setCheckList4] = useState(false);
    const [checkList5, setCheckList5] = useState(false);
    const [checkList6, setCheckList6] = useState(false);
    const [checkList7, setCheckList7] = useState(false);
    const [checkList8, setCheckList8] = useState(false);

    //View / Render
    return(<> 
        {showModalSegment?(
            <Modal
                id="regular-modal" 
                closeButton
                onClose={() => setShowModalSegment(false)}
                show={showModalSegment}
                title={t('notifyWrongValues')}
            >
                <p>{showMessage}</p>
            </Modal>
            ):null
        }
        <Container style={{margin: "10px 0"}}>
            <h4 style={{marginBottom: "12px"}}>{t('requestSpecialCondition')}</h4>
            {previusInformation?(
                <div>
                     <br /><h6>{t('checklistTitle')}</h6> <br />
                    <Row>
                        <Col xs="12" md="12">
                            <Checkbox 
                                id="checkbox-checked1" 
                                label={t('notBlackMarket')}
                                value={checkList1}
                                onChange={(e) => setCheckList1(e.target.checked)} 
                            />
                        </Col>
                        <Col xs="12" md="12">
                            <Checkbox
                                id="checkbox-checked2"
                                label={t('pressAgeOrNew')}
                                value={checkList2}
                                onChange={(e) => setCheckList2(e.target.checked)}
                            />
                        </Col>
                        <Col xs="12" md="12">
                            <Checkbox
                                id="checkbox-checked3"
                                label={t('businessObjective')}
                                value={checkList3}
                                onChange={(e) => setCheckList3(e.target.checked)}
                            />
                        </Col>
                        <Col xs="12" md="12">
                            <Checkbox
                                id="checkbox-checked4"
                                label={t('customerGrowth')}
                                value={checkList4}
                                onChange={(e) => setCheckList4(e.target.checked)}
                            />
                        </Col>
                        <Col xs="12" md="12">
                            <Checkbox
                                id="checkbox-checked5"
                                label={t('documentedProject')}
                                value={checkList5}
                                onChange={(e) => setCheckList5(e.target.checked)}
                            />
                        </Col>
                        <Col xs="12" md="12">
                            <Checkbox
                                id="checkbox-checked6"
                                label={t('noDoubleBenefits')}
                                value={checkList6}
                                onChange={(e) => setCheckList6(e.target.checked)}
                            />
                        </Col>
                        <Col xs="12" md="12">
                            <Checkbox
                                id="checkbox-checked7"
                                label={t('commercialMaturity')}
                                value={checkList7}
                                onChange={(e) => setCheckList7(e.target.checked)}
                            />
                        </Col>
                        <Col xs="12" md="12">
                            <Checkbox
                                id="checkbox-checked8"
                                label={t('justifiedRequest')}
                                value={checkList8}
                                onChange={(e) => setCheckList8(e.target.checked)}
                            />
                        </Col>
                    </Row>
                    <Row style={{marginTop: '10px'}}>
                        <Col xs="4" md="4">
                            <Select
                                id="objetivo-id"
                                label={t('objective')}
                                value={objetive ? [{ value: objetive, label: objetive }] : []}
                                options={[
                                    { value: 'Crecimiento de volumen (Print Volume)', label: t('printVolumeGrowth') },
                                    { value: 'Protección contra la competencia', label: t('competitionProtection') },
                                    { value: 'Extensión por instalación de hardware', label: t('hardwareExtension') },
                                    { value: 'Proyecto especial', label: t('specialProject') },
                                ]}
                                onChange={(e) => {setObjetive(e.value)}}
                                clearIcon={false}
                            /><br />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12" md="12">
                            <TextArea
                                id="justification-id"
                                value={justification}
                                label={t('Business Justification')}
                                maxLength="2500"
                                onChange={(e) => {setJustification(e)}}
                            /><br />
                        </Col>
                    </Row>
                    <Row style={{marginTop: '10px'}}>
                        <Col xs="4" md="4">
                            <TextBox
                                id="nameSend"
                                label={t('created_by')}
                                value={endUserContactName}
                                redOnly
                            />
                        </Col>
                        <Col xs="4" md="4">
                            <TextBox
                                id="dateSend"
                                label={t('dateCreate')}
                                value={new Date().toISOString().split('T')[0]}
                                redOnly
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12" md="12">
                            <Button 
                                style={{marginTop: '15px'}} 
                                onClick={() => setPreviusInformation(false)}
                                disabled={!(checkList1 && checkList2 && checkList3 && checkList4 
                                    && checkList5 && checkList6 && checkList7 && checkList8 && objetive != "" && justification != "")}
                            >{t('next')}</Button>
                        </Col>
                    </Row>
                </div>
            ):(
                <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                    <Stepper interactive onChange={handleOnChange} steps={stepItems} />
                    <div style={formStyle}>
                    <ThemeProvider density="high">
                        {currentIndex == 0 ? (<>
                            <Row>
                                <Col xs="4" md="4">
                                    <Select
                                        id="category-list"
                                        options={[{value: 1, label: 'Special condition'}, {value: 2, label: 'Ramp up'}, {value: 3, label: 'Ramp up Ligada'}]}
                                        value={category ? [category] : []}
                                        placeholder={t('category')}
                                        onChange={(e) => {setCategory(e.value); if(e.value=="1") setOpdNumber("")}}
                                        onClear={() => setCategory([])}
                                        readOnly={viewChannel}
                                    />
                                </Col>
                                <Col xs="4" md="4">
                                    <Select
                                        id="channel-list"
                                        label={t('channel')}
                                        options={channelList}
                                        value={channel ? [channel] : []}
                                        placeholder={t('channel')}
                                        onChange={(e) => { setChannel(e.value); fetchEndUsers(e.value); setChannelCombineClicks(e.value)}}
                                        disabled={!category||isLoading}
                                        readOnly={viewChannel}
                                    />
                                </Col>
                            </Row>
                            {(category == '2' )?(<>
                                <Row style={{marginTop: "20px"}}>
                                    <Col xs="4" md="4">
                                        <TextBox
                                            id="opd-number"
                                            value={opdNumber}
                                            label="OPD #"
                                            maxLength="14"
                                            onKeyPress={(event) => {
                                                if (opdNumber.length < 3) if (!/^[A-Za-z]+$/.test(event.key)) event.preventDefault();
                                                else if (!/[0-9]/.test(event.key)) event.preventDefault();
                                            }}
                                            onChange={(e) => {
                                                setOpdNumber(e);
                                                if (opdNumber.length == 3) setOpdNumber(opdNumber + "-")
                                            }}
                                        />
                                    </Col>
                                    <Col xs="4" md="4">
                                        <FilePicker 
                                            id="Files"
                                            label={t('selectFile')}
                                            accept=".pdf"
                                            onChange={(event) => {setFile(event.target.files[0]);}}
                                        />
                                    </Col>
                                </Row>
                            </>):(category == '3' )?(<>
                                <Row style={{marginTop: "20px"}}>
                                    <Col xs="4" md="4">
                                        <TextBox
                                            id="opd-number"
                                            value={opdNumber}
                                            label="OPD #"
                                            maxLength="14"
                                            onKeyPress={(event) => {
                                                if (opdNumber.length < 3) if (!/^[A-Za-z]+$/.test(event.key)) event.preventDefault();
                                                else if (!/[0-9]/.test(event.key)) event.preventDefault();
                                            }}
                                            onChange={(e) => {
                                                setOpdNumber(e);
                                                if (opdNumber.length == 3) setOpdNumber(opdNumber + "-")
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </>):(<></>)}
                            <Row style={{marginTop: "20px"}}>
                                <Col xs="4" md="4">
                                    <Select
                                        id="endUser-list"
                                        label={t('endUserName')}
                                        options={endUserList}
                                        value={endUser ? [endUser] : []}
                                        placeholder={t('endUserName')}
                                        disabled={channel==""}
                                        onChange={(e) => {setEndUser(e.value); fetchPress(e.value)}}
                                    />
                                </Col>
                                <Col xs="4" md="4">
                                    <Select
                                        id="Segmento-list"
                                        options={[{value: "GCP", label:"Commercial"},{value: "L&P", label:"Labels & Packaging"}]}
                                        value={segment}
                                        placeholder={t('segment')}
                                        disabled={endUser.length==0}
                                        onChange={(e) => { setSegmentFind(e.value)}}
                                        readOnly={segmentFlag}
                                    />
                                </Col>
                                <Col xs="4" md="4">
                                    {seriesList.length > 1 ? (
                                        <Select
                                            id="series-list"
                                            label={t("series")}
                                            options={seriesList}
                                            value={series}
                                            placeholder={t("series")}
                                            onChange={(e) => { fetchSpConditions(e.value); }}
                                        />
                                    ):(null)}
                                </Col>
                            </Row>
                            { (Number(series) != 0 && segment != "") ? (
                                Number(series) >= 3 ?(<>
                                    <Row style={{marginTop: "20px"}}>
                                        <Col xs="12" md="12">
                                            {pressListBySeriesFilter.length > 0 ? (
                                                <Table
                                                    name="press-table"
                                                    rowSelector="multiSelection"
                                                    onSelect={handleSelect}
                                                    rowSelectAllState={selectionState(pressListBySeriesFilter)}
                                                    onSelectAllPageItems={handleSelectAll}
                                                    columns={[
                                                        { id: "uid", index:"hidden" }, 
                                                        { id: "idPress", label: t('press id'), }, 
                                                        { id: "classification", label: t('classification'), }, 
                                                        { id: "series", label: t("series"), }, 
                                                        { id: "segment", label: t('segment'), }, 
                                                        { id: "installDate", label: t('installationDate'), }, 
                                                        { id: "dateEndUser", label: t('dateEndUser'), }, 
                                                        { id: "program", label: t('bonustable.table4'), }
                                                    ]}
                                                    data={pressListBySeriesFilter} 
                                                />
                                            ):(null)}<br />
                                        </Col>
                                    </Row>
                                </>) : (<><br /><h5>{t('applaySpecialCondition')}</h5></>)
                            ):(null) }
                        </>) 
                        : currentIndex == 1 ? (<>
                            <Row>
                                <Col xs="4" md="4">
                                    <Select
                                        id="special-condition-type-list"
                                        label={t('Special Condition Type')}
                                        options={specialConditionTypeList}
                                        value={specialConditionType ? [specialConditionType] : []}
                                        onChange={(e) => setSpecialConditionType(e.value)}
                                        onClear={() => setSpecialConditionType("") }
                                    /><br />
                                </Col>
                                {specialConditionType?(<>
                                    <Tooltip placement="top" contentHideDelayOnHover={0} content={tooltipDescription}>
                                        <IconInfo size={16} />
                                    </Tooltip>
                                </>):(<></>)}
                            </Row>
                            {specialConditionType?(<>
                                <div >
                                    {showFixedBonus({
                                        t,
                                        specialConditionType,
                                        seriesList,
                                        oneShotDisabled,
                                        whiteDisabled,
                                        percentage,
                                        minimumImp,
                                        setPercentage,
                                        setMinimumImp
                                    })}
                                    {showMaxCostPerImpression({
                                        t,
                                        specialConditionType,
                                        seriesList,
                                        oneShotDisabled,
                                        whiteDisabled,
                                        isLastTier,
                                        minPrint,
                                        maxPrint,
                                        blackCpp,
                                        otherCpp,
                                        oneShotCpp,
                                        whiteCpp,
                                        setMinPrint,
                                        setMaxPrint,
                                        setBlackCpp,
                                        setOtherCpp,
                                        setOneShotCpp,
                                        setWhiteCpp,
                                        setCompensationTable,
                                        compensationTable,
                                        setIsLastTier
                                    })}
                                    {showBonusSpecialTable({
                                        t,
                                        specialConditionType,
                                        minPrint,
                                        maxPrint,
                                        bonus,
                                        setMinPrint,
                                        setMaxPrint,
                                        setBonus,
                                        setBonusTable,
                                        bonusTable,
                                        setIsLastTier,
                                        isLastTier,
                                        setSpecialConditionType
                                    })}
                                    {showCombineClicks({
                                        t,
                                        specialConditionType,
                                        channelCombineClicks,
                                        endUserListCombineClicks,
                                        endUserCombineClicks,
                                        endUserNameCombine,
                                        setEndUserNameCombine,
                                        setEndUserCombineClicks,
                                        setCombineClicksList,
                                        combineClicksList,
                                        channelList
                                    })}
                                    {showTiersUp({
                                        t,
                                        specialConditionType,
                                        percentage,
                                        minimumImp,
                                        setPercentage,
                                        setMinimumImp
                                    })}
                                    {showMinumimDiscount({
                                        t,
                                        specialConditionType,
                                        minumimDiscount,
                                        setMinumumDiscount
                                    })}
                                    {showBonusLSDiscount({
                                        t,
                                        specialConditionType,
                                        lowCoverage,
                                        bonusLSDiscount,
                                        bonusLSDiscountSend,
                                        minPrintLS,
                                        maxPrintLS,
                                        bonusLS,
                                        setBonusLSDiscount,
                                        setBonusLSDiscountSend,
                                        setMinPrintLS,
                                        setMaxPrintLS,
                                        setBonusLS,
                                        setIsAddOneMin,
                                        setIsLastTierLS,
                                        isLastTierLS,
                                        isAddOneMin
                                    })}
                                    {showRunLength({
                                        t,
                                        specialConditionType,
                                        segmentSelected,
                                        minimumImp,
                                        setMinimumImp,
                                        series,
                                        percentage,
                                        setPercentage,
                                        MinimumPrint,
                                        setMinimumPrint
                                    })}
                                </div>
                            </>):(<></>)}
                        </>) 
                        : currentIndex == 2 ? (<>
                            <Row>
                                    <Col xs="4" md="4">
                                        <DatePicker
                                            id="stardate-id"
                                            label={t("specialcondition.startdate")}
                                            placeholder="YYYY-MM"
                                            format="YYYY-MM"
                                            value={startDate}
                                            onChange={(e) => setStartDate(e)}
                                            //calendarOrientation={['up']}
                                            monthYearNavigation={true}
                                            blockPastDates={true} 
                                        /><br />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="4" md="4">
                                        <TextBox
                                            id="effective-months"
                                            value={effectiveMonths}
                                            label={t('effMonth')}
                                            maxLength="2"
                                            disabled={!startDate}
                                            onKeyPress={ (event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); } }
                                            onChange={ (e) => { if (e != 0) setEffectiveMonths(e); else setEffectiveMonths(1); }  }
                                        /><br />
                                    </Col>
                                </Row>

                                {category == '2' || category == '3' ? (<></>):(<>
                                    {informationFromHP?(<></>):(<>
                                        <Row>
                                            <Col xs="4" md="4">
                                                <Select
                                                    id="objetivo-id"
                                                    label={t('objective')}
                                                    value={objetive ? [objetive] : []}
                                                    options={[
                                                        { value: 'Crecimiento de volumen (Print Volume)', label: t('printVolumeGrowth') },
                                                        { value: 'Protección contra la competencia', label: t('competitionProtection') },
                                                        { value: 'Extensión por instalación de hardware', label: t('hardwareExtension') },
                                                        { value: 'Proyecto especial', label: t('specialProject') },
                                                    ]}
                                                    onChange={(e) => {setObjetive(e.value)}}
                                                    clearIcon={false}
                                                /><br />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs="12" md="12">
                                                <TextArea
                                                    id="justification-id"
                                                    value={justification}
                                                    label={t('Business Justification')}
                                                    maxLength="2500"
                                                    onChange={(e) => {setJustification(e)}}
                                                /><br />
                                            </Col>
                                        </Row>
                                    </>)}
                                    <Row>
                                        <Col xs="12" md="12">
                                            <TextBox
                                                id="competition-id"
                                                value={competition}
                                                label={t('Competition')}
                                                onChange={(e) => {setCompetition(e)}}
                                            /><br />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12">
                                            <TextArea
                                                id="resultado-id"
                                                value={resultFuture}
                                                label={t('expectedResult')}
                                                maxLength="2500"
                                                onChange={(e) => {setResultFuture(e)}}
                                            /><br />
                                        </Col>
                                    </Row>
                                </>)}
                                
                                <Row>
                                    <Col xs="12" md="12">
                                        <TextArea
                                            id="comentarios-id"
                                            value={comments}
                                            label={t('comments')}
                                            maxLength="2500"
                                            onChange={(e) => {setComments(e)}}
                                        /><br />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="4" md="4">
                                        <TextBox
                                            id="contact-name"
                                            value={endUserContactName}
                                            label={t('contactName')}
                                            maxLength = "100"
                                            onChange={(e) => {setEndUserContactName(e)}}
                                            required
                                        />
                                    </Col>
                                    <Col xs="4" md="4">
                                        <TextBox
                                            id="contact-position"
                                            value={endUserContactPosition}
                                            label={t('jobPosition')}
                                            maxLength="100"
                                            onChange={(e) => {setEndUserContactPosition(e)}}
                                            required
                                        /><br />
                                    </Col>
                                </Row>
                        </>) 
                        : currentIndex == 3 ? (<>
                            <Container style={{margin: "10px 0"}}>
                                <h4 style={{marginBottom: "12px"}}>{t('End User and Press Information')}</h4>
                                <Row>
                                    <Col xs="4" md="4">
                                        <TextBox
                                            id="idCategory"
                                            value={category == 1 ? 'Special Condition' : category == 2 ? 'Ramp up' : 'Ramp Up Ligada'}
                                            label={t('category')}
                                            readOnly
                                        />
                                    </Col>
                                    <Col xs="4" md="4">
                                        <TextBox
                                            id="idChannel"
                                            value={channelList.find(x => x.value == channel).label}
                                            label={t('channel')}
                                            readOnly
                                        />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: "20px"}}>
                                    <Col xs="4" md="4">
                                        <TextBox
                                            id="idEnduser"
                                            value={endUserList.find(x => x.value == endUser).label}
                                            label={t('endUserName')}
                                            readOnly
                                        />
                                    </Col>
                                    {category == 2 ? (<>
                                        <Col xs="4" md="4">
                                            <TextBox
                                                id="idOpdNumber"
                                                value={opdNumber}
                                                label="OPD #"
                                                readOnly
                                            />
                                        </Col>
                                    </>):(<></>)}
                                </Row>
                                <Row style={{marginTop: "20px"}}>
                                    <Col xs="12" md="12">
                                        <Table
                                            name="press-table2"
                                            columns={[ 
                                                { id: "uid", index:"hidden" },
                                                { id: "idPress", label: t('press id'), }, 
                                                { id: "classification", label: t('classification'), }, 
                                                { id: "series", label: t("series"), }, 
                                                { id: "segment", label: t('segment'), }, 
                                                { id: "installDate", label: t('installationDate'), }, 
                                                { id: "dateEndUser", label: t('dateEndUser'), }
                                            ]}
                                            data={pressListBySeriesFilter}
                                        />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: "20px"}}>
                                    <Col xs="4" md="4">
                                        <DatePicker
                                            id="idStartDate"
                                            value={startDate}
                                            format="YYYY-MM"
                                            label={t("specialcondition.startdate")}
                                            disabled
                                        />
                                    </Col>
                                    <Col xs="4" md="4">
                                        <TextBox
                                            id="idEffectiveMonth"
                                            value={effectiveMonths}
                                            label={t('effMonth')}
                                            readOnly
                                        />
                                    </Col>
                                </Row>
                                <div style={{marginTop: "20px", marginBottom: "20px"}}>
                                    {showFixedBonusReview({
                                        t,
                                        specialConditionType,
                                        percentage,
                                        minimumImp,
                                    })}
                                    {showMaxCostPerImpressionReview({
                                        t,
                                        specialConditionType,
                                        compensationTable
                                    })}
                                    {showBonusSpecialTableReview({
                                        t,
                                        specialConditionType,
                                        bonusTable
                                    })}
                                    {showCombineClicksReview({
                                        t,
                                        specialConditionType,
                                        combineClicksList
                                    })}
                                    {showTiersUpReview({
                                        t,
                                        specialConditionType,
                                        percentage,
                                        minimumImp
                                    })}
                                    {showMinumimDiscountReview({
                                        t,
                                        specialConditionType,
                                        minumimDiscount
                                    })}
                                    {showBonusLSDiscountReview({
                                        t,
                                        specialConditionType,
                                        lowCoverage,
                                        bonusLSDiscount
                                    })}
                                    {showRunLengthReview({
                                        t,
                                        specialConditionType,
                                        segmentSelected,
                                        minimumImp,
                                        percentage,
                                        MinimumPrint,
                                        series
                                    })}
                                </div>

                                {category == '2' || category == '3' ? (<></>):(<>
                                    <Row>
                                        <Col xs="4" md="4">
                                            <TextBox
                                                id="objetivo-id"
                                                value={objetive}
                                                label={t('objective')}
                                                readOnly
                                            /><br />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12">
                                            <TextArea
                                                id="justification-id"
                                                value={justification}
                                                label={t('Business Justification')}
                                                readOnly
                                            /><br />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12">
                                            <TextBox
                                                id="competition-id"
                                                value={competition}
                                                label={t('Competencia')}
                                                readOnly
                                            /><br />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12">
                                            <TextArea
                                                id="resultado-id"
                                                value={resultFuture}
                                                label={t('expectedResult')}
                                                readOnly
                                            /><br />
                                        </Col>
                                    </Row>
                                </>)}
                                
                                <Row>
                                    <Col xs="12" md="12">
                                        <TextArea
                                            id="comentarios-id"
                                            value={comments}
                                            label={t('comments')}
                                            readOnly
                                        /><br />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="4" md="4">
                                        <TextBox
                                            id="contact-name"
                                            value={endUserContactName}
                                            label={t('contactName')}
                                            readOnly
                                        />
                                    </Col>
                                </Row>
                            </Container>
                        </>):(<></>)}
                    </ThemeProvider>
                    <div style={buttonsContainer}>
                        <Button
                            name="reset"
                            customStyle={resetButtonStyle}
                            small
                            onClick={handleResetButtonOnChange}
                            disabled={currentIndex == 0}
                        >
                        {t('back')}
                        </Button>
                        {currentIndex == 3 ? (<>
                            <Button
                                name="sendData"
                                customStyle={nextButtonStyle}
                                small
                                title={t('Submit')}
                                onClick={validateForm}
                            >
                                {t('Submit')}
                            </Button>
                        </>):(<>
                            <Button
                                name="button"
                                customStyle={nextButtonStyle}
                                small
                                onClick={handleNextButtonOnChange}
                                disabled={!selectedPress}
                            >
                            {t('next')}
                            </Button>
                        </>)}
                    </div>
                    </div>
                </div>
            )}
        </Container>
    </>);
}

export default NewSpecialConditionsProcess;